export default function TickGreenIcon({
    style,
    fill = "#10a64a",
}){
    return <svg style={style} width="24" height="24" viewBox="0 0 24 24" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M0.912675 15.8905C-1.90955 12.222 2.43023 6.74882 5.56299 10.2213C6.66649 11.4331 8.26607 13.2047 9.37543 14.4094L18.2991 1.25197C21.2932 -2.49448 26.0197 3.00473 23.0647 6.77008L11.9418 22.7457C11.6323 23.1409 11.2595 23.4559 10.8462 23.6716C10.4329 23.8872 9.98766 23.9989 9.53754 24H9.49848C8.70337 24.0021 7.93661 23.643 7.35007 22.9937C5.49659 20.915 2.84038 17.8653 0.92244 15.9071L0.912675 15.8905Z"/>
    </svg>
}